export default __webpack_public_path__ + "static/media/monster.ef7ffc6b.png";